<template>
  <div>
    <v-select
      :value="value"
      :items="salesAccountList"
      :loading="loading"
      item-text="name"
      item-value="id"
      label="担当営業"
      clearable
      @change="$emit('change', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'SalesAccountSelect',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    salesAccountList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
